import * as React from 'react';
import { useTranslation } from 'react-i18next';

import Avatar from './Avatar/Avatar.jsx';
import LanguageSelector from './LanguageSelector.jsx';
import { PageTitle } from './PageTitle.jsx';

import { useApplication } from '../AppContext';

const imgStyle = {
	height: '100px',
};

const avatarWrapperStyle = {
	display: 'inline-block',
	margin: '0 0 5px 0',
};

const Profile = () => {

	const { t } = useTranslation();
	const app = useApplication();
	const [name, setName] = React.useState(app?.userdata?.name ?? '');

	const updateStoredName = React.useCallback((newName) => {
		if (app?.userdata && newName !== app.userdata.name) {
			app.userdata.name = newName;
			app.save();
		}
	}, [app]);

	const handleNameChange = React.useCallback((e) => {
		const newName = e.target.value;
		setName(newName);
		updateStoredName(newName);
	}, [updateStoredName]);

	const handleAvatarClick = React.useCallback((e) => {
		e?.stopPropagation?.();
		e?.preventDefault?.();
		app.navigate('Avatar');
	}, [app]);

	const languageSection = React.useMemo(() => {
		return (
			<div>
				<label>
					{t('Language')}
				</label>
				<LanguageSelector />
			</div>
		);
	}, [t]);

	return (
		<div id="Profile" className="page1 profile">
			<div className="wrapper">
				<PageTitle>
					<h1>{t('Profile')}</h1>
				</PageTitle>
				<div
					className="avatar"
					style={avatarWrapperStyle}
				>
					<label>{t('Avatar')}</label>

					<Avatar
						id="imgAvatar"
						avatar={app?.userdata?.avatar}
						style={imgStyle}
					/>
					<a
						onClick={handleAvatarClick}
						className="simpleButtonOutLine"
					>
						{t('Change')}
					</a>
				</div>
				<div>
					<label>
						{t('Name')}
					</label>
					<input
						placeholder={t('Name')}
						value={name}
						onChange={handleNameChange}
						type="text"
					/>
				</div>
				{languageSection}
			</div>
		</div>
	);
};

export default React.memo(Profile);
